import React from 'react';
import { useDispatch } from 'react-redux';

import { getBackupMessages, reclaimBackup } from '../../../redux/id8/id8Actions';
import CommonMessagesOutput from '../common-messages-output/CommonMessagesOutput';
import BackupFilters from './filters/BackupFilters';

import scss from '../../Id8.module.scss';

function BackupTab({ bindAction, isShowGenerationForm }) {
  const dispatch = useDispatch();

  const handleSearchBackupMessages = ({ id }) => {
    dispatch(getBackupMessages({ id }));
  };

  return (
    <div className={scss.outputWrapper}>
      <BackupFilters onReclaim={reclaimBackup} />

      <CommonMessagesOutput
        bindAction={bindAction}
        searchFunction={handleSearchBackupMessages}
        isShowGenerationForm={isShowGenerationForm}
      />
    </div>
  );
}

export default BackupTab;
